import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import $service from './utils/service.js'
import global from '../static/gloabvar.js'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login','/simpleform']

router.beforeEach((to, from, next) => {
  NProgress.start()
  
  if(localStorage.getItem("Token")){
    next()
  }else{
    if (whiteList.indexOf(to.path) != -1 || to.path=="/") {
      // 在免登录白名单，直接进入
      next();
    } else {
      localStorage.setItem("wxrouterPath",to.fullPath);
      if(global.casEnable)
      {
        window.location.href = global.casloginUrl+`/login?redirect=${to.fullPath}` //
      }
      else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      }
      NProgress.done()
    }
  }
  // $service.get('/appapi/getIstoken').then(function(res) {
  //   if (res.code == 200) {
  //     localStorage.setItem("routerPath",to.fullPath);
  //     next()
  //   }else {
  //     // 没有token
  //     if (whiteList.indexOf(to.path) != -1 || to.path=="/") {
  //       // 在免登录白名单，直接进入
  //       next();
  //     } else {
  //       localStorage.setItem("wxrouterPath",to.fullPath);
  //       if(global.casEnable)
  //       {
  //         window.location.href = global.casloginUrl+`/login?redirect=${to.fullPath}` //
  //       }
  //       else {
  //       next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
  //       }
  //       NProgress.done()
  //     }
  //   }
  // })
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js